import cat_model from "models/cat_model";
import { useAsync } from "@iscr/xAppLib/Hooks/useAsync";

export const useAvailableConsults = () => {
	const { data: availableConsults, loading: isFetchingConsults } = useAsync(async () => {
		const { cat_tree_list } = await cat_model.get_cat_list({ cat_nm: "pharm" });

		return Object
			.values({ ...(cat_tree_list?.DocCons?.i || {}), ...(cat_tree_list?.subscr?.i || {})})
			.filter(category => category.c)
	});

	return { availableConsults, isFetchingConsults };
};